import API_URLS from "@constants/apiUrls";
import { api } from "services/customBaseQuery";
import { DraftData } from "interfaces/common.interface";

// ============================================================================
// API Endpoints
// ============================================================================

export const draftsAPI = api.injectEndpoints({
  endpoints: (build) => ({
    fetchDrafts: build.query<any, void>({
      query: () => {
        return {
          url: API_URLS.SAVED_ORDERS,
          method: "GET",
          credentials: "include",
        };
      },
      keepUnusedDataFor: 0,
      providesTags: ["Drafts"],
    }),

    removeDraft: build.mutation<any, string>({
      query: (url) => ({
        url,
        method: "PATCH",
        credentials: "include",
      }),
      invalidatesTags: ["Drafts"],
    }),

    sendDraft: build.mutation<
      any,
      {
        url: string;
        method: "POST" | "PUT" | "PATCH" | "DELETE";
        body?: any;
      }
    >({
      query: ({ url, body, method }) => ({
        url,
        method,
        body,
        credentials: "include",
      }),
      invalidatesTags: ["Drafts"],
    }),

    summaryDraft: build.mutation<any, string>({
      query: (url) => ({
        url,
        method: "GET",
        credentials: "include",
      }),
    }),
  }),
});

export const {
  useFetchDraftsQuery,
  useRemoveDraftMutation,
  useSummaryDraftMutation,
  useSendDraftMutation,
} = draftsAPI;
